import React from 'react';
import Img from 'react-image';
import { connect } from 'react-redux';
import ReactSound from 'react-sound';
import styled from 'styled-components';
import { backToMainPage, setBirdNumber } from '../../../actions/hatch-egg';
import { useImagesContext } from '../../../contexts/ImagesContext';
import {
  getstudentInfo,
  playFeatherRedeem,
  playUpdate,
} from '../../../services/game-play';
import { DivClick, ImgClick } from '../../utility';
import AnimationWithSound from '../AnimationWithSound';
import soundBackground from '../sounds/collection-background.mp3';
import soundBirdGetting from '../sounds/collection-bird-getting.mp3';
import soundFeatherGetting from '../sounds/collection-feather-getting.ogg';
import soundHatching from '../sounds/collection-hatching.mp3';

const EFFECT_STAGE = {
  FEATHER_GETTING: 1,
  HATCHING: 2,
  BIRD_GETTING: 3,
};

const ColloectionPage = ({
  student,
  config,
  birdNumber,
  backToMainPage,
  setBirdNumber,
  duplicated,
}) => {
  const { images } = useImagesContext();
  const [data, setData] = React.useState({
    breakCount: 0,
    hatchCount: 0,
    birdMap: 0,
    feather: null,
  });
  const [effectStage, setEffectStage] = React.useState([]);
  const [isProcessing, setIsProcessing] = React.useState(false);
  console.debug('ColloectionPage birdNumber:', birdNumber);
  console.debug('ColloectionPage effectStage:', effectStage);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const studentInfo = await getstudentInfo(student.id);
        setData({
          breakCount: studentInfo.data.capture,
          hatchCount: studentInfo.data.egg,
          birdMap: studentInfo.data.birdMap,
          feather: studentInfo.data.feather,
        });
      } catch (error) {
        console.error('Error fetching student info:', error);
      }
    };
    fetchData();
  }, []);

  const birdMap = data.birdMap;

  const displayCollectedBirds = (birdMapLocal) => {
    const birds = [];
    for (let i = 0; i < 12; i++) {
      if (birdMapLocal & (1 << i)) {
        birds.push(
          <FullScreenImage
            key={`collection-bird-${i}`}
            src={
              images[`collection-bird-${String(i + 1).padStart(2, '0')}.png`]
            }
          />
        );
      }
    }
    return birds;
  };

  const handleFeatherGettingSoundEnd = () => {
    setEffectStage([]);
    setIsProcessing(false);
    setBirdNumber({ birdNumber: null, duplicated: false });
  };

  const handleBirdGettingSoundEnd = () => {
    setEffectStage([]);
    setBirdNumber({ birdNumber: null, duplicated });
    if (duplicated) {
      setEffectStage([EFFECT_STAGE.FEATHER_GETTING]);
    } else {
      setIsProcessing(false);
    }
  };

  React.useEffect(() => {
    if (birdNumber !== null) {
      setEffectStage([EFFECT_STAGE.HATCHING]);
      setTimeout(() => {
        setEffectStage([EFFECT_STAGE.HATCHING, EFFECT_STAGE.BIRD_GETTING]);
      }, 7200);
    }
  }, [birdNumber]);

  const collectedBirds = displayCollectedBirds(
    !duplicated ? birdMap ^ (1 << (birdNumber - 1)) : birdMap
  );

  return (
    <Container>
      <Background src={images['collection-background.jpg']} />
      <ReactSound
        url={soundBackground}
        playStatus={config.isMutedSound ? 'STOPPED' : 'PLAYING'}
        loop={true}
      ></ReactSound>
      {birdMap > 0 && collectedBirds}
      <BackButton
        src={images['collection-back.png']}
        onClick={async () => {
          // await playUpdate(student.id, 100, 1);
          backToMainPage();
        }}
      />
      <Feather
        background={images['collection-feather.png']}
        onClick={() => {
          console.debug('Feather clicked');
          if (data.feather >= 10 && !isProcessing && birdNumber === null) {
            setIsProcessing(true);
            playFeatherRedeem(student.id).then((res) => {
              console.debug('playFeatherRedeem result:', res);
              if (res.data.birdNumber === null) {
                // No bird got, only feather deducted
                setIsProcessing(false);
                return;
              }
              setData((prevData) => ({
                ...prevData,
                feather: res.data.feather,
                birdMap: res.data.birdMap,
              }));
              setBirdNumber({
                birdNumber: res.data.birdNumber,
                duplicated: res.data.duplicated,
              });
            });
          }
        }}
      >
        <FeatherCount>
          {duplicated ? data.feather - 1 : data.feather}
        </FeatherCount>
      </Feather>
      {effectStage.includes(EFFECT_STAGE.HATCHING) && (
        <>
          <AnimationWithSound
            imageUrl={images['collection-hatching.png']}
            soundFile={soundHatching}
            playSound={!config.isMutedSound}
            // onSoundEnd={handleHatchingSoundEnd}
            imageRight={70}
            imageBottom={0}
            imageWidth={754}
            imageHeight={568}
          />
        </>
      )}
      {birdNumber > 0 && effectStage.includes(EFFECT_STAGE.BIRD_GETTING) && (
        <>
          <AnimationWithSound
            imageUrl={
              images[
                `collection-bird-${String(birdNumber).padStart(
                  2,
                  '0'
                )}-effect.png`
              ]
            }
            soundFile={soundBirdGetting}
            playSound={!config.isMutedSound}
            onSoundEnd={handleBirdGettingSoundEnd}
          />
        </>
      )}
      {effectStage.includes(EFFECT_STAGE.FEATHER_GETTING) && (
        <>
          <AnimationWithSound
            imageUrl={images['collection-feather-getting.png']}
            soundFile={soundFeatherGetting}
            playSound={!config.isMutedSound}
            onSoundEnd={handleFeatherGettingSoundEnd}
          />
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
`;

const Background = styled.img`
  top: 0px;
  left: 0px;
  width: 1920px;
  height: 1080px;
  position: absolute;
  object-fit: contain;
`;

const FullScreenImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const BackButton = styled(ImgClick)`
  position: absolute;
  right: 14px;
  bottom: 14px;
  width: 155px;
  height: 114px;
`;

const Feather = styled(DivClick)`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 233px;
  height: 131px;
  background-image: url(${(props) => props.background});
  background-size: contain;
  background-repeat: no-repeat;
`;

const FeatherCount = styled.span`
  position: relative;
  display: inline-block;
  left: 120px;
  width: 80px;
  height: 70px;
  top: 30px;
  font-size: 56px;
  font-weight: bold;
  color: #ffffff;
  //   border: 1px solid black;
  font-family: PSLxText;
  text-align: center;
`;

const mapStateToProps = ({ student, config, hatchEgg }) => ({
  student,
  config,
  birdNumber: hatchEgg.birdNumber,
  duplicated: hatchEgg.duplicated,
});

const mapDispatchToProps = {
  // Your dispatch actions here
  backToMainPage,
  setBirdNumber,
};

export default connect(mapStateToProps, mapDispatchToProps)(ColloectionPage);
